<!-- HIDE ON MED AND SMALL DEVICES SHOW ON LARGE -->
<mat-card-content *ngIf="electionArr.length > 0">
  <!-- HIDE ON MED AND SMALL DEVICES SHOW ON LARGE -->
  <div class="container-fluid">
    <div class="row justify-content-center mt-1">
      <!-- MOBILE VIEW -->
      <div class="col-12 mt-5 pt-3 md:hidden">
        <div class="row">
          <mat-form-field class="col-md-12">
            <mat-select matInput placeholder="Election" disableOptionCentering panelClass="panelClass"
              class="initialism" [(ngModel)]="selectedElection" (ngModelChange)="getOffices()" required>
              <mat-option *ngFor="let election of electionArr" [value]="election" class="initialism text-uppercase">
                {{ election.election }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-accordion class="col-12">
            <mat-expansion-panel *ngFor="let office of officeArr">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ office.office | uppercase }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="row mb-2" *ngFor="let nominee of office.nominees">
                <div class="col-9">
                  <div class="row text-uppercase" style="font-size: 8pt; cursor: pointer;">
                    <div class="col-2">
                      <img src="{{ nominee.passport }}" onerror="this.src='assets/images/man.png'" class="img" />
                    </div>
                    <div class="col-10" [class]="nominee.color ? 'text-success' : ''">
                      <span>{{ nominee.lastname }} {{ nominee.firstname }}</span><br />
                      <small class="text-muted">{{ nominee.party }} | {{ nominee.student_id }}</small>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <button mat-raised-button *ngIf="!office.voted" (click)="vote(nominee, office)">
                    Vote
                  </button>
                  <button mat-raised-button *ngIf="
                      office.voted && office.voted_nominee == nominee.nominee_id
                    " disabled>
                    You Voted
                  </button>
                </div>
                <div *ngIf="selectedElection.result_visible == 1" class="col-12 ml-2">
                  <small><b>Total Votes: {{ nominee.vote_count }}</b></small>
                </div>
              </div>
              <p *ngIf="office.nominees.length == 0">
                No Nominee found
              </p>
            </mat-expansion-panel>
          </mat-accordion>
          <div *ngIf="officeArr.length == 0" class="mt-2">
            <div class="card">
              <div class="card-body row">
                NO OFFICE FOUND
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DESKTOP VIEW -->
      <div class="col-md-12 hidden md:block">
        <div class="card-block shadow  ml-3 mr-3 pr-3 pl-3">
          <div class="p-1 bg-white">
            <div class="row">
              <mat-form-field class="col-md-12">
                <mat-select matInput placeholder="Election" disableOptionCentering panelClass="panelClass"
                  class="initialism" [(ngModel)]="selectedElection" (ngModelChange)="getOffices()" required>
                  <mat-option *ngFor="let election of electionArr" [value]="election" class="initialism text-uppercase">
                    {{ election.election }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <div class="col-6">
                <input
                  placeholder="Search Office"
                  class="form-control initialism"
                />
              </div> -->
            </div>
          </div>
          <div class="mt-2">
            <div class="row shadow etheme p-3">
              <div class="col-md-1">
                #
              </div>
              <div class="col-md-2">
                Office
              </div>
              <div [class]="
                  selectedElection.result_visible == 0 ? 'col-md-3' : 'col-md-2'
                ">
                Party
              </div>
              <div [class]="
                  selectedElection.result_visible == 0
                    ? 'col-md-4'
                    : 'col-md-3 pl-5'
                ">
                Nominee
              </div>
              <div *ngIf="selectedElection.result_visible == 1" class="col-md-2">
                Total Votes
              </div>
              <div class="col-md-2">
                Vote
              </div>
            </div>
          </div>
          <cdk-virtual-scroll-viewport itemSize="60" class="viewport1">
            <div *cdkVirtualFor="let i = index; let office; of: officeArr"
              class="cardsource bg-white animated fadeInUp shadow p-2 m-2">
              <div class="row text-uppercase">
                <div class="col-md-1 mt-2 font-bold">
                  {{ i + 1 }}
                </div>
                <div class="col-md-2 mt-2">
                  {{ office.office }}
                </div>
                <div class="col-md-9 mt-2">
                  <div class="row mb-2" *ngFor="let nominee of office.nominees">
                    <div [class]="
                        selectedElection.result_visible == 0
                          ? 'col-md-4'
                          : 'col-md-3'
                      ">
                      {{ nominee.party | uppercase }}
                    </div>
                    <div [class]="
                        selectedElection.result_visible == 0
                          ? 'col-md-5'
                          : 'col-md-4'
                      ">
                      <div class="row" style="font-size: 8pt; cursor: pointer;">
                        <div class="col-2">
                          <img src="{{ nominee.passport }}" onerror="this.src='assets/images/man.png'" class="img" />
                        </div>
                        <div class="col-10" [class]="nominee.color ? 'text-success' : ''">
                          <span>{{ nominee.lastname }}
                            {{ nominee.firstname }}</span><br />
                          <small class="text-muted">{{ nominee.party }} |
                            {{ nominee.student_id }}</small>
                        </div>
                      </div>
                    </div>
                    <div class="col-2" *ngIf="selectedElection.result_visible == 1">
                      <b>{{ nominee.vote_count }}</b>
                    </div>
                    <div class="col-3">
                      <button mat-raised-button *ngIf="!office.voted" (click)="vote(nominee, office)">
                        Vote
                      </button>
                      <button mat-raised-button *ngIf="
                          office.voted &&
                          office.voted_nominee == nominee.nominee_id
                        " disabled>
                        You Voted
                      </button>
                    </div>
                  </div>
                  <p *ngIf="office.nominees.length == 0">
                    No Nominee found
                  </p>
                </div>
              </div>
            </div>
            <div *ngIf="officeArr.length == 0" class="mt-2">
              <div class="card">
                <div class="card-body row">
                  NO OFFICE FOUND
                </div>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom">
    <!-- <button
      mat-fab
      class="material-icons actBtn"
      color="primary"
      (click)="addElectionOffice()"
      *ngIf="p_level == 'w' || p_level == 'd'"
    >
      <i class="material-icons">add</i>
    </button> -->
  </div>
</mat-card-content>

<div class="container-fluid mt-5" *ngIf="electionArr.length == 0">
  <div class="row">
    <div class="card-body pt-4 pb-4">
      <h6 align="center" class="mb-3" style="font-size: 14px;">
        NO ELECTION AVAILABLE
      </h6>
      <p align="center" class="mt-2">
        <!-- <button class="btn sbc-btn etheme" routerLink="/election/election-setup">
                    Create Election
                </button> -->
      </p>
    </div>
  </div>
</div>